module.exports = __webpack_public_path__ + "static/media/Manual_Maker_App_Screen.9275d3a1.png";